module.exports = __webpack_public_path__ + "static/media/biker.fcc0600d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/biker.jpg
// module id = 401
// module chunks = 0